export enum PermissionType {
  View = 'view',
  Update = 'upd',
  Add = 'ins',
  Delete = 'del',
  Load = 'load',
}
